import React, { Component } from 'react';

import { Row, Col, Card } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Approvals/Approvals.css";

import LawsInside from "./LawsInside.js";

const content = (
     <p>
          قسمت اول -تشكيل و موضوع
          <br/>
          ماده ۱- به منظور تنظيم و تعميم و هدايت امر بيمه در ايران و حمايت بيمه گذاران و بيمه شدگان و صاحبان حقوق آنها همچنين به منظور اعمال نظارت دولت بر اين فعاليت موسسه اي به نام بيمه مركز ي ايران طبق مقررات اين قانون به صورت شركت سهامي تاسيس مي گردد.
          <br />
          ماده ۲- سرمايه بيمه مركزي ايران پانصد ميليون ريال است كه به پنجاه سهم ده ميليون ريالي با نام تقسيم مي شود و تمامي آن متعلق به دولت و غير قابل انتقال است و افزايش آن با تصويب مجمع عمومي امكان پذير است . مبلغ مزبور از محل اندوخته هاي شركت سهامي بيمه ايران تامين خواهد شد.
          <br />
          ماده ۳- مركز اصلي بيمه مركزي ايران تهران است و بيمه مركزي ايران مي تواند در هر جا كه لازم بداند به شركت سهامي بيمه ايران نمايندگي بدهد.
          <br />
          ماده ۴- بيمه مركزي ايران تابع قوانين و مقررات عمومي مربوط به دولت و دستگاههايي كه با سرمايه دولت تشكيل شده اند نمي باشد مگر آنكه در قانون مربوط صراحتا“ از بيمه مركزي ايران نام برده شده باشد ولي نسبت به مواردي كه در اين قانون پيش بيني نشده باشد بيمه مركزي ايران تابع قانون تجارت است.
          <br />
          قسمت دوم -وظايف و اختيارات
          <br /><br/>
          ماده ۵- بيمه مركزي ايران داراي وظايف و اختيارات زير است:
         <br/>
          ۱- تهيه آيين نامه و مقرراتي كه براي حسن اجراي امر بيمه درايران لازم باشد با توجه به مفاد اين قانون
          <br />
          ۲- تهيه اطلاعات لازم از فعاليتهاي كليه موسسات بيمه كه در ايران كار مي كنند
          <br />
          ۳- انجام بيمه هاي اتكايي اجباري
          <br />
          ۴- قبول بيمه هاي اتكايي اختياري از موسسات داخلي يا خارجي
          <br />
          ۵- واگذاري بيمه هاي اتكايي به موسسات داخلي يا خارجي در هر مورد كه مقتضي باشد
          <br />
          ۶- اداره صندوق تامين خسارتهاي بدني و تنظيم آيين نامه آن موضوع ماده ۱۰ قانون بيمه اجباري مسئوليت مدني دارندگان وسائل نقليه موتوري زميني در مقابل شخص ثالث مصوب دي ماه ۱۳۴۷
          <br />
          ۷- ارشاد و هدايت و نظارت بر موسسات بيمه و حمايت از آنها در جهت حفظ سلامت بازار بيمه و تنظيم بر امور بيمه اتكايي و جلوگيري از رقابت هاي مكارانه و ناسالم
          <br />
          تبصره :بيمه مركزي ايران ملزم به حفظ اسرار موسساتي است كه به موجب اين قانون حق نظارت بر آنها را دارا مي باشد و به هيچ وجه نبايد از اطلاعاتي كه در جهت اجراي اين قانون بدست مي آورد جز در مواردي كه قانون معين مينمايد استفاده كند.
          <br />
          قسمت سوم -اركان بيمه مركزي ايران
          <br />
          ماده ۶- بيمه مركزي ايران داراي اركان زير است:
          <br />
          ۱- مجمع عمومي
          <br />
          ۲- شوراي عالي بيمه
          <br />
          ۳- هيات عامل
          <br />
          ۴- بازرسان
          <br />
          فصل اول- مجمع عمومي
          <br />
          ماده ۷- مجمع عمومي بيمه مركزي ايران مركب از وزير امور اقتصادي و دارايي ، وزير كار و امور اجتماعي ،‌ هيات عامل و بازرسان بدون داشتن حق راي در جلسه شركت خواهند كرد.( به موجب تصويب نامه شماره ۴۹۷۰۸ مورخ ۲۶/۸/۱۳۵۳ هيات وزيران مستند به ماده ۴ قانون تشكيل وزارت امور اقتصادي و دارايي به شرح متن اصلاح شده است.)
          <br />
          ماده ۸- مجمع عمومي عادي به دعوت رئيس كل بيمه مركزي ايران سالي يك مرتبه حداكثرتا پايان شهريور ماه تشكيل مي شود.
          <br />
          مجمع عمومي فوق العاده به دعوت رئيس كل بيمه مركزي ايران و يا به پيشنهاد هر يك از اعضا مجمع عمومي تشكيل خواهد شد.
          <br />
          رئيس كل بيمه مركزي ايران موظف است ظرف ده روز پس از دريافت پيشنهاد تشكيل جلسه مجمع عمومي را كتبا“ دعوت كند . در دعوتنامه دستور جلسه ،‌ روز و محل انعقاد جلسه ذكر خواهد شد.
          <br />
          هيچ موضوعي را نمي توان در مجمع عمومي عادي يا فوق العاده مطرح كرد مگر آن كه قبلا“ جزو دستور قرار داده شده باشد.
          <br />
          ماده ۹- وظايف مجمع عمومي به شرح زير است :
          <br />
          الف - تعيين خط مشي كلي .
          <br />
          ب - رسيدگي و اظهار نظر نسبت به گزارش سالانه رئيس كل بيمه مركزي ايران .
          <br />
          ج - رسيدگي و تصويب بودجه و ترازنامه و حساب سود وزيان و ترتيب تقسيم سود.
          <br />
          د - تصويب سازمان و آيين نامه هاي مالي و اداري بيمه مركزي ايران.
          <br />
          هـ - تصويب مقررات استخدامي با رعايت بند پ ماده ۲ قانون استخدام كشوري .
          <br />
          و - انتخاب بازرسان .
          <br />
          ز - تعيين حقوق رئيس كل و اعضا هيات عامل و حق الزحمه بازرسان .
          <br />
          ح - تصميم نسبت به هر موضوعي كه از طرف رئيس كل بيمه مركزي ايران جزو دستور قرار داده شده باشد
          <br />
          فصل دوم - شوراي عالي بيمه
          <br />
          ماده ۱۰ - شوراي عالي بيمه از اشخاص زير تشكيل مي شود :
          <br />
          ۱- رئيس كل بيمه مركزي ايران
          <br />
          ۲- معاون وزارت امور اقتصادي و دارايي
          <br />
          ۳- معاون وزارت بازرگاني
          <br />
          ۴- معاون وزارت كار و امور اجتماعي
          <br />
          ۵- معاون وزارت تعاون و امور روستاها
          <br />
          ۶- رئيس شركت سهامي بيمه ايران
          <br />
          ۷- مدير عامل يكي از موسسات بيمه به انتخاب سنديكاي بيمه گران ايران
          <br />
          ۸- يك نفر كارشناس امور حقوقي به انتخاب مجمع عمومي
          <br />
          ۹- يك نفر كارشناس در امور بيمه به انتخاب مجمع عمومي
          <br />
          ۱۰- يك نفر مطلع در امور بيمه به انتخاب رئيس اطاق بازرگاني و صنايع و معادن ايران
          <br />
          تبصره : ‌اعضا شوراي عالي بيمه موضوع بندهاي ۷و ۸و ۹و ۱۰ براي مدت سه سال انتخاب مي شوند و انتخاب مجدد آنان بلامانع است
          <br />
          ماده ۱۱- رياست شورايعالي بيمه بدون شركت دراخذ راي بارئيس كل بيمه مركزي ايران ودرغياب اوباقائم مقام خواهدبود.
          <br />
          ماده ۱۲- اعضاي شوراي عالي بيمه قبل از شروع به كار بايد در مجمع عمومي سوگند ياد كنند كه در انجام وظايف شوراي عالي بيمه نهايت دقت و مراقبت را مبذول دارند و كليه تصميمات خود را به صلاح كشور اتخاذ نمايند و اسرار عالي بيمه را حفظ كنند.
          <br />
          ماده ۱۳- جلسات شوراي عالي بيمه حداقل ماهي يكبار به دعوت رئيس شوراي عالي بيمه تشكيل خواهد شد و در صورتي كه حداقل چهار نفر از اعضا شوراي عالي بيمه كتبا تقاضاي تشكيل جلسه را بنمايند رئيس شوراي عالي بيمه موظف است ظرف يك هفته اعضاي شوراي عالي را براي تشكيل جلسه دعوت كند.
          <br />
          ماده ۱۴- جلسه شوراي عالي بيمه با حضور حداقل شش نفر از اعضا رسميت مي يابد و تصميمات با اكثريت پنج راي حاضر در جلسه رسمي معتبر و قابل اجرا است . هنگام رسيدگي و اخذ راي نسبت به موسسه بيمه اي كه يكي از اعضاي شوراي عالي به نحوي در آن سهيم است آن عضو در راي شركت نخواهد كرد.
          <br />
          ماده ۱۵- صورت جلسات مذاكرات شوراي عالي بيمه در دفتري ثبت و به امضاي رئيس شوراي عالي بيمه رسيده و در بيمه مركزي ايران نگاهداري مي شود.
          <br />
          ماده۱۶- شوراي عالي بيمه داراي دبيرخانه اي خواهد بود كه سازمان آن را شوراي عالي بيمه تصويب خواهد كرد رئيس و كاركنان دبيرخانه از بين كاركنان بيمه مركزي ايران انتخاب مي شوند.
          <br />
          ماده ۱۷- وظايف شوراي عالي بيمه به شرح زير است:
          <br />
          ۱- رسيدگي و اظهار نظر نسبت به صدور پروانه تاسيس يا لغو پروانه موسسات بيمه طبق مقررات اين قانون و پيشنهاد آن به مجمع عمومي
          <br />
          ۲-تصويب نمونه ترازنامه كه بايد مورد استفاده موسسات بيمه قرار گيرد
          <br />
          ۳-تعيين انواع معاملات بيمه و شرایط عمومي بيمه نامه ها و نظارت بر امور بيمه هاي اتكايي
          <br />
          ۴-تعيين ميزان كارمزد و حق بيمه مربوط به رشته هاي مختلف بيمه مستقيم
          <br />
          ۵-تصويب آيين نامه هاي لازم براي هدايت امر بيمه و فعاليت موسسات بيمه
          <br />
          ۶- رسيدگي و اظهار نظر نسبت به گزارش بيمه مركزي ايران درباره عمليات و فعاليتهاي موسسات بيمه در ايران كه حداقل هر شش ماه يكبار بايد تسليم شود
          <br />
          ۷- اظهار نظر در باره هرگونه پيشنهاد كه از طرف رئيس شوراي عالي بيمه به آن ارجاع مي شود
          <br />
          ۸- انجام ساير وظايفي كه اين قانون براي آن تعيين نموده است.
          <br />
          فصل سوم - هيات عامل
          <br />
          ماده ۱۸- هيات عامل بيمه مركزي ايران مركب از رئيس كل و قائم مقام رئيس كل و معاونان بيمه مركزي ايران خواهد بود.
          <br />
          ماده ۱۹- رئيس كل بيمه مركزي ايران و قائم مقام او به پيشنهاد وزير امور اقتصادي و دارايي و تصويب هيات وزيران و معاونان بيمه مركزي ايران به پيشنهاد رئيس كل بيمه مركزي ايران و موافقت وزير امور اقتصادي و دارايي به موجب تصويبنامه هيات وزيران منصوب مي شوند.
          <br />
          ماده ۲۰- رئيس كل و قائم مقام رئيس كل بيمه مركزي ايران براي مدت چهار سال منصوب مي شوند و انتصاب مجدد آنان بلامانع است.
          <br />
          ماده ۲۱- رئيس كل بيمه مركزي ايران بالاترين مقام اجرايي و اداري بيمه مركزي ايران مي باشد.
          <br />
          ماده ۲۲- وظايف و اختيارات رئيس كل بيمه مركزي ايران به شرح زير است:
          <br />
          الف - نظارت در اجراي اين قانون و آيين نامه هاي مربوط به آن
          <br />
          ب - نمايندگي بيمه مركزي ايران در مقابل اشخاص و موسسات دولتي يا خصوصي و دادگاهها و ساير مراجع قضايي و غير قضايي با حق توكيل و سازش و ساير اختيارات مندرج در ماده ۶۲ قانون آئين دادرسي مدني
          <br />
          ج - تفويض قسمتي از اختيارات خود و حق امضا به قائم مقام و يا معاونان و يا روسا يا كارمندان و تعيين وظايف آنان
          <br />
          د - تقديم گزارش وضع حسابها و امور بيمه مركزي ايران به مجمع عمومي
          <br />
          هـ - تقديم گزارش عمليات و فعاليت هاي موسسات بيمه در ايران و شوراي عالي بيمه
          <br />
          ماده ۲۳- در غياب رئيس كل بيمه مركزي ايران قائم مقام رئيس كل داراي كليه اختيارات و وظايف قانوني او خواهد بود
          <br />
          فصل چهارم - بازرسان
          <br />
          ماده ۲۴- بيمه مركزي ايران داراي دو نفر بازرس (به موجب اساسنامه سازمان حسابرسي مصوب ۱۷/۶/۱۳۶۶ وظيفه بازرسان به سازمان حسابرسي محول گرديده است.) كه اطلاعات و تجارب كافي در امور بيمه و حسابداري داشته باشند خواهد بود كه يك نفر از آنان از طرف وزير امور اقتصادي و دارايي و ديگري از طرف وزير بازرگاني پيشنهاد و با تصويب مجمع عمومي براي يك سال تعيين خواهند شد ،‌ انتخاب مجدد بازرسان بلامانع است .
          <br />
          ماده ۲۵- بازرسان حق دارند هرگونه اطلاعي را از بيمه مركزي ايران بخواهند ولي حق دخالت مستقيم در امور بيمه مركزي ايران را ندارند.
          <br />
          رسيدگي به ترازنامه سالانه وظيفه اصلي بازرسان مي باشد ترازنامه بيمه مركزي ايران يكماه قبل از تشكيل مجمع عمومي تسليم بازرسان خواهد شد تا گزارش در باره آن تهيه و ضمن اظهار نظر به مجمع
          <br />
          قسمت چهارم - مقررات مختلف
          <br />
          ماده ۲۶- رئيس كل و ساير اعضا هيات عامل در مدت تصدي خود نمي توانند عضويت شركتها و موسسات بازركاني را قبول نمايند و يا در ساير دستكاههاي دولتي يا ملي سمتي داشته باشند.
          <br />
          تبصره : تدريس در دانشگاهها و موسسات آموزش عالي و قبول سمتهاي غير موظف در موسسات خيريه و اجتماعي و آموزشي بلامانع است.
          <br />
          ماده ۲۷- اسناد مالي و اوراق بهادار و چك هاي بيمه مركزي ايران با دو امضا معتبر خواهد بود.
          <br />
          ماده ۲۸- بيمه مركزي ايران مجاز خواهد بود كه موجوديهاي نقدي خود را به صورتحساب جاري و يا سپرده نزد بانك ملي ايران (اين بانك در بانك ملت ادغام شده است.)نگاهداري نمايد. يا براساس بودجه مصوب از محل سرمايه و ذخاير و اندوخته هاي خود و صندوق تامين خسارتهاي بدني تا مبلغ يكصد ميليون ريال در هر سال با تصويب هيات عامل و مازاد بر آن با تصويب مجمع عمومي به هر نوع عمليات ديگر از جمله خريد سهام و مشاركت در بانكها و شركت هاي ديگر با حق فروش و انتقال آنها كه براي توسعه و پيشرفت وظايف بيمه مركزي ضروري يا مفيد باشد مبادرت نمايد. (به موجب قانون اصلاح قانون تاسيس بيمه مركزي ايران و بيمه گري مصوب ۶/۳/۱۳۵۳ به شرح متن اصلاح شده است.)
          <br />
          ماده ۲۹- اعضا شوراي عالي بيمه و مشاورين و اعضا اداري شوراي عالي بيمه و افرادي كه شوراي عالي بيمه در اجراي وظايف خود به آنها مراجعه مي كند و رئيس كل و ساير اعضا هيات عامل و بازرسان و كليه كاركنان بيمه مركزي ايران بايد از افشاي اطلاعات محرمانه اي كه در اجراي وظايف محوله بدست مي آورند خودداري نمايند و الا مشمول مقررات ماده ۱۳۸ قانون مجازات عمومي خواهند شد.
          <br />
          ماده ۳۰- شركت سهامي بيمه ايران عمليات خود را جز آنچه به موجب بندهاي ۱و ۲و ۳و ۶و ۷ ماده ۵ اين قانون جز وظايف و اختيارات بيمه مركزي ايران قرار داده شده است بر طبق اساسنامه خود ادامه خواهد داد.
          <br />
          وزارتخانه ها و موسسات و شركت هاي دولتي و شهرداريها و هر موسسه ديگري كه اكثريت سرمايه آن متعلق به دولت يا سازمانهاي مزبور مي باشد و يا تحت نظر دولت و يا سازمانهاي مزبور اداره مي شوند موظفند بيمه هاي خود را منحصرا“ در شركت سهامي بيمه ايران انجام دهند.
          <br />
          اين حكم شامل شركت ملي نفت ايران - شركت ملي ذوب آهن ايران - شركت هواپيمايي ملي ايران - بانك مركزي ايران - بانك ملي ايران - سازمان گسترش و نوسازي صنايع ايران و صندوق توسعه كشاورزي خواهد بود مگر آن كه مجمع عمومي هر يك از اين موسسات نسبت به بيمه آنها تصميم ديكري اتخاذ نمايد.
          <br />
          تبصره :‌دولت مكلف است ظرف چهار ماه از تاريخ تصويب اين قانون اساسنامه جديد شركت مزبور را براي تصويب كميسيونهاي دارايي و استخدام مجلسين تقديم كند.
          <br />
          بخش دوم - بيمه ‏گرى
          <br />
          قسمت اول - مؤسسات بيمه
          <br />
          فصل اول - كليات
          <br />
          ماده ۳۱. عمليات بيمه در ايران به وسيله شركت‏هاى سهامى عام ايرانى كه كليه سهام آنها بانام بوده و با رعايت اين قانون و طبق قانون تجارت به ثبت رسيده‏باشند انجام خواهد گرفت.
          <br />
          تبصره ۱- فعاليت مؤسسات بيمه خارجى مشمول مقررات فصل چهارم اين قانون خواهد بود.
          <br />
          تبصره ۲- تشخيص فعاليت‏هايى كه به آن عمليات بيمه اطلاق مى‏شود با شوراى عالى بيمه خواهد بود.
          <br />
          ماده ۳۲. تعداد سهامداران يك مؤسسه بيمه ايرانى نبايد كمتر از ده شخص حقيقى يا حقوقى باشد.
          <br />
          ماده ۳۳. هر شخص حقيقى يا حقوقى نمى تواند بيش از ۲۰ درصد سهام يك مؤسسه بيمه ايرانى را دارا باشد، نصاب ۲۰ درصد شامل اقارب نسبى و سببى درجه يك از طبقه اول صاحب سهم نيز خواهد بود.
          <br />
          ماده ۳۴. احكام مواد ۳۱ و ۳۲ و ۳۳ شامل مؤسسات بيمه‏ اى كه صاحب سهم آن دولت يا بنياد پهلوى[۱] است نمى‏شود.
          <br />
          ماده ۳۵. واگذارى سهام مؤسسات بيمه ايرانى غيردولتى به اشخاص حقيقى يا حقوقى تبعه خارج تا بيست درصد با موافقت بيمه مركزى ايران مجاز است و بيش از آن موكول به پيشنهاد بيمه مركزى ايران و تأييد شوراى عالى بيمه و تصويب هيئت وزيران خواهد بود در مورد اخير انتقال سود سهام سهامداران خارجى در هر سال نبايد از دوازده درصد مجموع سرمايه پرداخت شده و سود انتقال نيافته سال‏ هاى قبل تجاوز كند.[۲]
          <br />
          تبصره - انتقال سهام مؤسسات بيمه ايرانى به دولت‏هاى خارجى يا انتقال بيش از ۴۹ درصد سهام آنها به اشخاص حقيقى يا حقوقى خارجى مطلقاً ممنوع است. انتقال سهام بين سهامداران اتباع خارجى بايد با موافقت قبلى بيمه مركزى ايران صورت گيرد.
          <br />
          ماده ۳۶. مؤسسات بيمه ايرانى با سرمايه حداقل يك‏صد ميليون ريال تشكيل مى‏شود كه بايد ۵۰ درصد آن نقداً پرداخت شده باشد ميزان وديعه‏اى كه عندالاقتضا براى هر يك از رشته‏ هاى بيمه در نظر گرفته خواهد شد در آيين ‏نامه‏ اى كه از طرف بيمه مركزى ايران تهيه و به تصويب شوراى عالى بيمه مي ‏رسد تعيين خواهد شد.
          <br />
          ماده ۳۷. ثبت هر مؤسسه بيمه در ايران موكول به ارائه پروانه تأسيس كه از طرف بيمه مركزى ايران صادر مى‏شود خواهد بود همچنين ثبت هر گونه تغييرات بعدى در اساسنامه و ميزان سرمايه و سهام مؤسسات بيمه‏اى كه به ثبت رسيده باشند موكول به ارائه موافقت بيمه مركزى ايران مى‏باشد.
          <br />
          فصل دوم - صدور پروانه
          <br />
          ماده ۳۸. براى انجام عمليات بيمه در تمام رشته ‏ها يا رشته‏ اى معين بايد قبلاً طبق مقررات اين فصل از بيمه مركزى ايران پروانه تحصيل گردد براى تحصيل پروانه مذكور متقاضى بايد مدارك و اطلاعات زير را به بيمه مركزى ايران تسليم كند:
          <br />
          ۱. اساسنامه مؤسسه.
          <br />
          ۲. ميزان سرمايه مؤسسه.
          <br />
          ۳. صورت كامل اسامى شركا و مديران و تابعيت و تعداد سهام هر يك از آنها.
          <br />
          ۴. ميزان سهام نقدى و غيرنقدى و نحوه پرداخت آنها.
          <br />
          ۵. اسناد و مدارك و اطلاعات ديگرى كه بيمه مركزى ايران براى احراز صلاحيت مالى و فنى مؤسسه و حسن شهرت مديران لازم بداند.
          <br />
          ماده ۳۹. تقاضاى صدور پروانه به بيمه مركزى ايران تسليم مي ‏شود بيمه مركزى ايران مكلف است حداكثر ظرف مدت شصت روز از تاريخ تسليم آخرين مدارك و اطلاعات خواسته شده با رعايت مفاد بند يك ماده ۱۷ نظر مجمع عمومى را اعم از قبول يا رد تقاضا كتباً به متقاضى اعلام نمايد.
          <br />
          هرگاه متقاضى نسبت به نظر اعلام شده اعتراض داشته باشد مى تواند ظرف سى روز اعتراض خود رابه هيئت وزيران تسليم نمايد. نظرى كه هيئت وزيران اتخاذ نمايد قطعى خواهدبود.
          <br />
          فصل سوم - ابطال پروانه
          <br />
          ماده ۴۰. پروانه بيمه براى تمام رشته‏ ها و يا رشته‏ هاى معينى درموارد زير پس از موافقت شوراى ‏عالى بيمه با تصويب مجمع عمومى بيمه مركزى ايران ابطال خواهد شد:
          <br />
          ۱. در صورت تقاضاى دارنده پروانه.
          <br />
          ۲. در صورتى كه مؤسسه بيمه تا يك‏سال پس از صدور پروانه عمليات خود را شروع نكرده باشد.
          <br />
          ۳. در مواردى كه به تشخيص بيمه مركزى ايران وضع مالى مؤسسه بيمه طورى باشد كه نتواند به تعهدات خود عمل نمايد يا بر بيمه مركزى ايران ثابت گردد كه ادامه فعاليت مؤسسه به زيان بيمه‏ شدگان و بيمه‏ گذاران و يا صاحبان حقوق آنها است.
          <br />
          ماده ۴۱. در مواردى كه مؤسسه بر خلاف اساسنامه خود يا قوانين و مقررات بيمه رفتار كند به پيشنهاد بيمه مركزى ايران و تصويب شوراى عالى بيمه به‏ طور موقت از قبول بيمه در رشته‏ هاى معين ممنوع خواهد شد.
          <br />
          ماده ۴۲. در صورتى كه پروانه مؤسسه بيمه‏اى طبق ماده ۴۰ باطل گردد مؤسسه مزبور مي ‏تواند ظرف سى روز به هيئت وزيران مراجعه و لغو تصميم متخذه را درخواست كند. نظر هيئت وزيران قطعى است.
          <br />
          ماده ۴۳. صدور يا لغو پروانه مؤسسه بيمه و اطلاعاتى كه از لحاظ حفظ منافع بيمه‏ گذاران و بيمه‏ شدگان و صاحبان حقوق آنها لازم باشد به هزينه خود مؤسسه بيمه توسط بيمه مركزى ايران در روزنامه رسمى كشور و يكى از روزنامه ‏هاى كثيرالانتشار تهران و در صورتى كه مؤسسه بيمه در شهر يا شهرهاى ديگر شعبه يا نمايندگى داشته باشد در يكى‏از روزنامه‏ هاى آن شهرها نيز در دو نوبت به فاصله يك ماه آگهى خواهدشد.
          <br />
          ماده ۴۴. در صورتى كه پروانه مؤسسه بيمه ‏اى براى يك يا چند رشته به ‏طور دايم لغو شود بيمه مركزى ايران با تصويب شوراى عالى بيمه كليه سوابق و اسناد مربوط به حقوق و تعهدات (پرتفوى Portefeuille) مؤسسه مزبور را به شركت سهامى بيمه ايران انتقال خواهد داد و يا ترتيب خاص ديگرى را كه متضمن منافع بيمه‏ گذاران و بيمه‏ شدگان و صاحبان حقوق آنها باشد خواهد داد.
          <br />
          فصل چهارم – مقررات مربوط به موسسات بيمه خارجي
          <br />
          ماده ۴۵. از تاريخ تصويب اين قانون شروع فعاليت مؤسسات بيمه خارجى در ايران موكول به پيشنهاد بيمه مركزى ايران و تأييد شوراى عالى بيمه و تصويب هيئت وزيران خواهد بود.
          <br />
          ماده ۴۶. مؤسسات بيمه خارجى بايد طبق آيين ‏نامه‏اى كه به پيشنهاد بيمه مركزى ايران به تصويب شوراى عالى بيمه مي ‏رسد مبلغى براى هر يك از دو رشته بيمه‏ هاى زندگى و ساير انواع بيمه نزد بيمه مركزى ايران توديع ‏نمايند. مبلغ ‏اين وديعه در هريك از دو موردمذكور از پانصد هزار دلار يا معادل آن از ارزهاى مورد قبول بانك‏ مركزى‏ ايران‏ كمترنخواهد بود.
          <br />
          هر يك از مؤسسات بيمه خارجى بايد درآمدهاى خود را سال ‏به ‏سال به وديعه مزبوراضافه كند تا در هر مورد مبلغ‏ وديعه حداقل به دو برابر مبلغ مصوب شوراى عالى بيمه برسد.
          <br />
          افزايش وديعه مازاد بر مبالغ فوق اختيارى است.
          <br />
          ماده ۴۷. انتقال درآمد مؤسسات بيمه خارجى پس از تكميل وديعه مذكور در ماده ۴۶ به خارج بلامانع خواهد بود مشروط بر اين‏كه رقم انتقالى در هر سال از ۱۰ درصد مبلغى كه به ‏عنوان وديعه در نزد بيمه مركزى ايران است تجاوز ننمايد.
          <br />
          تبصره - ترتيب انتقال درآمد مازاد بر وديعه به مأخذ ده درصد در سال مذكور در اين ماده موكول به پيشنهاد بيمه مركزى ايران و تأييد شوراى عالى بيمه و تصويب هيئت وزيران خواهد بود.
          <br />
          ماده ۴۸. مؤسسات بيمه خارجى كه در ايران كار مي ‏كنند بايد نماينده‏اى كه در ايران مقيم و داراى اختيارات لازم براى اداره كردن تمام كارهاى مؤسسه در ايران و انجام تعهدات از طرف مؤسسه بيمه اصلى باشد معرفى نمايند. نماينده مذكور مسئول كليه عمليات مؤسسه بيمه اصلى در ايران خواهد بود و بايد داراى اختيارنامه ‏اى باشد كه ضمن آن حدود اختيارات او مشخص گرديده و حق انتخاب نماينده مجاز يا قائم‏ مقام به جاى خود به او داده شده باشد.
          <br />
          نماينده مزبور موظف است كليه بيمه‏ هاى منعقد شده در ايران را شخصاً يا به‏ وسيله قائم مقام يا نماينده مجاز خود بدون اين‏كه تصويب مؤسسه بيمه اصلى لازم باشد امضا نمايد و بتواند در دعاوى خوانده يا خواهان قرار گيرد و حق توكيل و سازش داشته‏ باشد.
          <br />
          ماده ۴۹. نماينده مؤسسات بيمه خارجى فقط تا حدودى كه از مؤسسه بيمه اصلى اختيار دارد اقدام به بيمه در ايران خواهد نمود و در صورتى كه در هر يك از رشته‏ هاى بيمه از مؤسسه بيمه اصلى سلب اجازه بيمه كردن به‏ طور موقت يا دايم بشود و يا مؤسسه بيمه اصلى از نماينده خود جزئاً يا كلاً سلب اختيار كند بايد مراتب را كتباً به بيمه مركزى ايران اطلاع دهد.
          <br />
          ماده ۵۰. مؤسسات بيمه خارجى علاوه بر مقررات اين قانون و آيين‏ نامه‏ هاى اجرايى مربوط مشمول مقررات عمومى مربوط به شركت‏ها و مؤسسات خارجى نيز خواهند بود.
          <br />
          قسمت دوم - انحلال و ورشكستگى
          <br />
          ماده ۵۱. درصورتى كه ورشكستگى يك مؤسسه بيمه اعلام بشود دادگاه مكلف است قبل از اتخاذ هر گونه تصميم نظر بيمه مركزى ايران را جلب نمايد . بيمه مركزى ايران از تاريخ وصول استعلام دادگاه بايد ظرف ۱۵ روز نظريه خود را كتباً به دادگاه اعلام دارد. دادگاه با توجه به نظريه بيمه مركزى ايران تصميم مقتضى اتخاذ خواهد كرد.
          <br />
          ماده ۵۲. ابطال پروانه يك مؤسسه بيمه براى كليه عمليات بيمه‏ اى از موارد انحلال مؤسسه است و در اين صورت مفاد ماده ۴۴ اين قانون اجرا خواهد شد.
          <br />
          ماده ۵۳. تصفيه مؤسسه بيمه ورشكسته طبق قانون تجارت به‏ عمل مي ‏آيد. در نقاطى كه اداره تصفيه امور ورشكستگى وجود ندارد دادگاه بيمه مركزى ايران را به ‏عنوان قائم مقام اداره تصفيه تعيين مي ‏نمايد و در حوزه دادگاه‏هاى شهرستانى كه اداره تصفيه در آن‏جا تأسيس گرديده‏ است اداره تصفيه با معاونت بيمه مركزى ايران امر تصفيه را انجام خواهد داد.
          <br />
          قسمت سوم - انتقال عمليات و ادغام
          <br />
          ماده ۵۴. مؤسسات بيمه مي ‏توانند با موافقت بيمه مركزى ايران و تصويب شوراى عالى بيمه تمام يا قسمتى از پرتفوى (Portefeuille) خود را با كليه حقوق و تعهدات ناشى از آن به يك يا چند مؤسسه بيمه مجاز ديگر واگذار كنند.
          <br />
          ماده ۵۵. تقاضاى انتقال پرتفوى (Portefeuille) يك مؤسسه بيمه به مؤسسات ديگر بيمه دوبار به فاصله ده روز در روزنامه رسمى كشور و در يكى از روزنامه ‏هاى كثيرالانتشار تهران و عنداللزوم در يكى از روزنامه‏ هاى محلى به هزينه متقاضى از طرف بيمه مركزى ايران آگهى خواهد شد.
          <br />
          ماده ۵۶. پس از انقضاى سه ماه از تاريخ آخرين آگهى بيمه مركزى ايران در صورت حصول اطمينان از اين‏كه در اين انتقال هيچ‏يك از حقوق بيمه‏ شدگان و بيمه‏ گذاران و صاحبان حقوق آنها تضييع نخواهد شد موافقت خود را با انتقال پرتفوى كتباً به مؤسسه بيمه متقاضى اعلام خواهد داشت.
          <br />
          ماده ۵۷. در صورت موافقت بيمه مركزى ايران با انتقال پرتفوى اين انتقال براى كليه بيمه‏ شدگان و بيمه‏ گذاران و صاحبان حقوق آنها از تاريخ انتقال معتبر خواهد بود.
          <br />
          ماده ۵۸. يك يا چند مؤسسه بيمه مي ‏توانند با رعايت مواد ۵۶-۵۵ و ۵۷ با موافقت بيمه مركزى ايران و تصويب شوراى عالى بيمه در يك مؤسسه بيمه ديگر ادغام شوند.
          <br />
          ماده ۵۹. بيمه مركزى ايران به منظور حفظ حقوق بيمه‏ گذاران و بيمه‏ شدگان و صاحبان حقوق آنها يا به ملاحظات اقتصادى و حمايت امر بيمه مي ‏تواند با تأييد شوراى عالى بيمه و تصويب مجمع عمومى بيمه مركزى ايران مؤسسات بيمه‏ اى را كه وضع مالى يا ادارى آنها رضايت‏بخش نيست مكلف نمايد كه در يكى از مؤسسات بيمه ديگرى كه موافق باشند ادغام شوند و در صورتى كه ادغام صورت نگيرد پروانه مؤسسه‏ اى كه وضع مالى يا ادارى آن رضايت‏بخش نيست طبق مقررات اين قانون لغو خواهد شد. تصميم بيمه مركزى ايران علاوه بر ابلاغ كتبى به مؤسسات موردنظر در روزنامه رسمى كشور و در يكى از روزنامه‏ هاى كثيرالانتشار تهران و عنداللزوم در يكى از روزنامه‏ هاى محلى به اطلاع عموم خواهد رسيد.
          <br />
          قسمت چهارم - مقررات مختلف
          <br />
          ماده ۶۰. اموال مؤسسات بيمه همچنين ودايع مذكور در مواد ۳۶ و ۴۶ تضمين حقوق و مطالبات بيمه‏ گذاران، بيمه ‏شدگان و صاحبان حقوق آنان است و در صورت انحلال يا ورشكستگى مؤسسه بيمه بيمه‏ گذاران و بيمه‏ شدگان و صاحبان حقوق آنان نسبت به ساير بستانكاران حق تقدم دارند. در ميان رشته‏ هاى مختلف بيمه حق تقدم با بيمه عمر است.
          <br />
          مؤسسات بيمه نمي ‏توانند بدون موافقت قبلى بيمه مركزى ايران اموال خود را صلح حقوق نمايند و يا به رهن واگذار كنند و يا موضوع هر نوع معامله با حق استرداد قرار دهند.
          <br />
          دفاتر اسناد رسمى موظفند هنگام انجام اين قبيل معاملات موافقتنامه بيمه مركزى ايران را مطالبه و مفاد آن‏را در سند منعكس كنند.
          <br />
          ماده ۶۱. مؤسسات بيمه موظفند اندوخته‏ هاى فنى و قانونى نگه ‏دارند و در حساب‏هاى خود نحوه به‏كار افتادن آنها را به ‏طور مشخص منعكس نمايند. انواع اندوخته‏ هاى فنى و قانونى براى هر يك از رشته‏ هاى بيمه و ميزان و طرز محاسبه همچنين‏ ترتيب به‏ كار انداختن اين اندوخته‏ها و نحوه ارزيابى اموال منقول و غيرمنقولى كه نماينده اندوخته‏ هاى مؤسسات بيمه است از طرف شوراى عالى بيمه تعيين خواهد شد.
          <br />
          ماده ۶۲. كليه ‏مؤسسات‏ بيمه‏ موظفند ترازنامه ‏و حساب‏هاى سود و زيان خود را طبق نمونه‏ اى كه از طرف بيمه مركزى ايران تهيه و به تصويب شوراى عالى بيمه مى‏رسد تنظيم نمايند و پس از تصويب نسخه‏ اى از آن را براى بيمه مركزى ايران ارسال دارند.
          <br />
          ماده ۶۳. مؤسسات بيمه موظفند ترازنامه خود را در روزنامه رسمى كشور و يكى از روزنامه ‏هاى كثيرالانتشار تهران درج نمايند.
          <br />
          ماده ۶۴. اشخاصى كه در ايران يا در خارجه به علت ارتكاب جنايت يا دزدى يا خيانت در امانت يا كلاهبردارى يا صدور چك بي ‏محل يا اختلاس يا معاونت در يكى از جرايم فوق محكوم شده‏ باشند و ورشكستگان به تقصير نمي ‏توانند جزو مؤسسين يا مديران مؤسسات بيمه باشند. همچنين واگذارى نمايندگى به اين اشخاص و اشتغال به دلالى از طرف آنان ممنوع است.
          <br />
          ماده ۶۵. در صورتى كه به حكم دادگاه مسلم شود كه ورشكستگى مؤسسه بيمه به علت تقصير و تقلب مدير يا مديران بوده‏است در صورت عدم تكافوى دارايى مؤسسه مديران متضامناً مسئول پرداخت طلب بيمه‏ گذاران و بيمه ‏شدگان و صاحبان حقوق آنان خواهند بود.
          <br />
          ماده ۶۶. عرضه بيمه جز به‏وسيله اشخاص زير ممنوع است:
          <br />
          ۱. مؤسسات بيمه.
          <br />
          ۲. نمايندگان بيمه.
          <br />
          ۳. دلالان رسمى بيمه.
          <br />
          تبصره - هر كارمند يا نماينده بيمه كه اقدام به عرضه بيمه نمايد بايد داراى كارت شناسايى از طرف مؤسسه بيمه مربوط باشد. نام دلال رسمى يا نماينده بيمه كه بيمه‏نامه وسيله او عرضه شده‏است بايد در بيمه‏ نامه ذكر شود.
          <br />
          ماده ۶۷. مؤسسات بيمه و نمايندگان و دلالان رسمى بيمه مسئول جبران خساراتى مى‏باشند كه در اجراى وظايفشان به سبب تقصير و يا مسامحه آنها يا كاركنانشان به ديگران وارد آيد.
          <br />
          ماده ۶۸. پروانه دلالى رسمى بيمه به‏ وسيله بيمه مركزى ايران صادر خواهد شد و آيين‏ نامه دلالان رسمى بيمه به پيشنهاد بيمه مركزى ايران به تصويب شوراى عالى بيمه خواهد رسيد.
          <br />
          ماده ۶۹. هر مؤسسه بيمه در رشته يا رشته‏ هاى معينى كه پروانه بيمه ندارد رأساً و يا به ‏وسيله نمايندگان خود قبول بيمه نمايد مكلف به جبران خسارت زيان ديده خواهد بود.
          <br />
          تبصره - هر شخص حقيقى يا حقوقى كه بدون داشتن پروانه از مؤسسه بيمه تحت عنوان نمايندگى بيمه براى هر يك از رشته ‏ها قبول بيمه نمايد به مجازات مقرر در ماده ۲۳۸ قانون مجازات عمومى محكوم خواهد شد.
          <br />
          ماده ۷۰. بيمه‏ هاى زير بايد منحصراً به‏ وسيله مؤسسات بيمه ‏اى كه بر اساس اين قانون اجازه فعاليت دارند انجام گيرد:
          <br />
          الف) بيمه اموال منقول يا غيرمنقول موجود در ايران.
          <br />
          ب) بيمه حمل و نقل كالاى وارداتى كه قرارداد خريد آن در ايران منعقد مى‏شود يا اعتبار اسنادى آن در ايران باز شده است.
          <br />
          تبصره - تجهيزات نظامى مورد نياز وزارت دفاع و پشتيبانى نيروهاى مصلح كه فاقد امكان ساخت در داخل كشور بوده و فروشندگان آن تجهيزات حمل و نقل كالاهاى مورد معامله را انحصاراً توسط بيمه ‏هاى كشور فروشنده بيمه مى‏نمايند، با پيشنهاد وزير دفاع و پشتيبانى نيروهاى مسلح و تأييد بيمه مركزى ايران و موافقت وزير امور اقتصادى و دارايى از شمول بند )ب( اين ماده مستثنى مى‏باشد.[۳]
          <br />
          ج) بيمه مربوط به كارگران و مستخدمين خارجى به استثناى بيمه عمر و حوادث شخصى در مدت اقامت در ايران.
          <br />
          د) بيمه مربوط به ايرانيان مقيم ايران.
          <br />
          ماده ۷۱. كليه مؤسسات بيمه كه در ايران فعاليت مى‏نمايند بايد ۵۰ درصد در رشته بيمه‏ هاى زندگى و ۲۵ درصد در ساير رشته‏ ها از معاملات بيمه‏ اى مستقيم خود را نزد بيمه مركزى ايران بيمه اتكايى نمايند. بيمه مركزى ايران مكلف است باتوجه‏به ظرفيت قبولى هر يك از مؤسسات بيمه‏ اى كه در ايران كار مى‏كنند تمام يا قسمتى از بيمه اتكايى مجدد سهميه اتكايى اجبارى دريافتى را درصورت تساوى شرايط به آنها واگذار نمايد.
          <br />
          تبصره - آنچه مؤسسات بيمه به‏ عنوان اتكايى قبول ميكنند از شمول اين ماده خارج است.
          <br />
          ماده ۷۲. نحوه واگذارى بيمه اتكايى اجبارى و ميزان كارمزد و مشاركت در سود آن براى هر رشته بيمه به‏ وسيله شوراى عالى بيمه تعيين خواهد شد.
          <br />
          ماده ۷۳. مؤسسات بيمه كه در ايران فعاليت مى‏كنند موظف خواهند بود معادل ۳۰ درصد از مازاد سهميه بيمه اتكايى اجبارى از معاملات مستقيم خود را با همان شرايطى كه در خارج بيمه اتكايى مى‏نمايند به بيمه مركزى ايران واگذار كنند.
          <br />
          درصورتى كه بيمه مركزى ايران به هر علت از قبول آن استنكاف بنمايد مؤسسات مزبور مجاز خواهند بود در خارج از ايران بيمه اتكايى نمايند. انتقال ارز بابت اين ۳۰ درصد موكول به ارائه اجازه بيمه مركزى ايران خواهد بود.
          <br />
          ماده ۷۴. مؤسسات بيمه اعم از ايرانى يا خارجى كه تا تاريخ تصويب اين قانون به موجب مقررات قبلى به ثبت رسيده‏اند و مشغول فعاليت‏هاى بيمه‏اى مى‏باشند براى رشته ‏هايى كه در آن فعاليت مى‏كنند احتياج به كسب پروانه جديد نخواهند داشت ولى در هر حال موظفند ظرف هيجده ماه از تاريخ تصويب اين قانون وضع خود را با مقررات اين قانون تطبيق دهند در غير اين صورت پروانه آنها لغو خواهد شد. شوراى عالى بيمه مى‏تواند با توجه به دلايل و مقتضيات اين مدت را يك‏بار تمديد نمايد.
          <br />
          ماده ۷۵. مؤسسات بيمه كه در ايران كار مي ‏كنند عضو سنديكاى بيمه‏ گران ايران شناخته مى‏ شوند. اساسنامه اين سنديكا به‏ وسيله بيمه مركزى ايران با جلب نظر اعضاى سنديكا تدوين مى‏شود و حداكثر ظرف شش ماه پس از تشكيل بيمه مركزى ايران به تصويب شوراى عالى بيمه خواهد رسيد.
          <br />
          ماده ۷۶. مؤسسات بيمه كه در ايران فعاليت مي ‏نمايند ملزم به رعايت دستورات بيمه مركزى ايران كه در حدود اين قانون و آيين‏ نامه ‏هاى اجرايى آن صادر مى‏ شود خواهند بود.
          <br />
          ماده ۷۷. كليه قوانين و مقررات مغاير با اين قانون از تاريخ تصويب اين قانون ملغى است.
          <br />
          قانون فوق مشتمل بر هفتاد و هفت ماده و ده تبصره پس از تصويب مجلس سنا در تاريخ روز شنبه ۲۹/۳/۱۳۵۰ در جلسه فوق‏ العاده عصر روز يكشنبه سى‏ام خرداد ماه يك‏ هزار و سيصدو پنجاه شمسى به تصويب مجلس شوراى ملى رسيد.
          <br />
          ۱- نام بنياد ياد شده بعد از انقلاب به بنياد علوى تغيير يافته است.
          <br />
          ۲- به موجب قانون اصلاح قانون تأسيس بيمه مركزى ايران و بيمه‏ گرى مصوب ۶/۳/۱۳۵۳ به شرح متن اصلاح شده است.
          <br />
          ۱- اين تبصره به صورت ماده واحده در جلسه علنى روز دوشنبه ۳/۲/۱۳۸۰ مجلس شوراى اسلامى تصويب و در تاريخ ۱۲/۲/۱۳۸۰ به تأييد شوراى نگهبان رسيده است كه به ماده ۷۰ قانون تأسيس بيمه مركزى ايران و بيمه ‏گرى مصوب ۳۰/۳/۱۳۵۰ الحاق مى‏ شود.
     </p>
);
const SpecificTwoInside = props => {
     return props.size === "laptopdesktop" ? (
          <div>
               <LawsInside title="قانون تاسيس بيمه مركزی ايران و بيمه گری" text={content} size="laptopdesktop" />
          </div>
     ) : props.size === "tablet" ? (
          <div>
               <LawsInside title="قانون تاسيس بيمه مركزی ايران و بيمه گری" text={content} size="tablet" />
          </div>

     ) : (
          <div>
               <LawsInside title="قانون تاسيس بيمه مركزی ايران و بيمه گری" text={content} />
          </div>
     );
};

export default SpecificTwoInside;
